class BaseAccessRule {
  constructor(resourceClaims, type) {
    this.resourceClaims = resourceClaims;
    this.type = type;
  }
  filterClaims(checkedClaims) {
    return checkedClaims.filter((claim) => claim.type === this.type);
  }
  formatResourceClaims(prefix) {
    return `${prefix}: ${this.resourceClaims.map((claim) => claim.toString()).join(", ")}`;
  }
}
export {
  BaseAccessRule
};
//# sourceMappingURL=BaseAccessRule.js.map
